import { LinkOutIcon } from "../../Icons/LinkOutIcon";
import { useEstateGrunnbokQuery } from "../../Requests/estateApi";
import { CadastreIdentity } from "../../Types/EstateTypes";

const EstateGrunnbok = (props: { matrikkelenhetIdent: CadastreIdentity }) => {
  const {data: pdfUrl, isFetching: loadingGetPdf, isError: loadingGetPdfFailed} = useEstateGrunnbokQuery(props.matrikkelenhetIdent);
  return (
    <>
      <p>
        Grunnboken er et offentlig register, som viser tinglyste rettigheter og
        forpliktelser i eiendom. Grunnboken var tidligere en bok med håndskrevne
        ark, og er i dag et dataregister som forvaltes av Kartverket.
      </p>
      <button
        className="ikta-button"
        disabled={loadingGetPdf}
        onClick={() => 
          {
            if(pdfUrl)
              window.open(pdfUrl);
          }
        }
      >
        {loadingGetPdf ? "Henter grunnbokutskrift" : "Åpne grunnbokutskrift"}
        <div className="ikta-linkout">
          <LinkOutIcon/>
        </div>
      </button>
      {loadingGetPdfFailed ? <p>Kunne ikke hente grunnboksutskrift</p> : ""}
    </>
  );
};
export default EstateGrunnbok;
